import { Component, OnInit } from '@angular/core';
import { OfferteServiceService } from '../service/offerte-service.service';
import { Offerte } from '../model/offerte';
import { ActivatedRoute } from '@angular/router';
import { Fornitore } from '../model/fornitore';
import { FornitoreServiceService } from '../service/fornitore-service.service';
import { NgxCarousel } from 'ngx-carousel';
import { Meta } from'@angular/platform-browser';

@Component({
  selector: 'app-listaofferte',
  templateUrl: './listaofferte.component.html',
  styleUrls: ['./listaofferte.component.scss']
})


export class ListaofferteComponent implements OnInit {
  public carousel: NgxCarousel;
  idcomodity: number;
  idfornitore: number;
  private sub: any;

  lstOfferte: Array<Offerte>;
  fornitore: Fornitore;
  lstOfferteAlternative: Array<Offerte>;

  constructor(private route: ActivatedRoute,private service : OfferteServiceService,private serviceFornitore : FornitoreServiceService,private meta: Meta) {


  }

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
      this.idcomodity = +params['idcomodity']; // (+) converts string 'id' to a number
      this.idfornitore = +params['idfornitore'];

      // this.lstOfferte = this.service.getOfferteByIdFornitoreIdComodity(this.idfornitore, this.idcomodity);
      this.lstOfferte=null;
      this.service.getOfferteByIdFornitoreIdComodity(this.idfornitore, this.idcomodity).subscribe(data => this.lstOfferte=data);

      // this.fornitore = this.serviceFornitore.getfornitoribyId(this.idfornitore);
      this.fornitore=null;
      this.serviceFornitore.getfornitoribyId(this.idfornitore).subscribe(data =>
        {
          this.fornitore=data;
          var FornitoreDescrizione="";
          var Fornitorekyewords="";
          if (this.idfornitore==1) { FornitoreDescrizione="Iren Luce Gas e Servizi"; Fornitorekyewords=""; }
          if (this.idfornitore==2) { FornitoreDescrizione="Gritti";Fornitorekyewords=""; }
          if (this.idfornitore==3) { FornitoreDescrizione="SegnoVerde";Fornitorekyewords=""; }
          // if (this.idfornitore==4) { FornitoreDescrizione="Atena";Fornitorekyewords=""; }
          if (this.idfornitore==5) { FornitoreDescrizione="Global Power Plus";Fornitorekyewords=""; }
          // if (this.idfornitore==6) { FornitoreDescrizione="Fastweb";Fornitorekyewords=""; }
          if (this.idfornitore==7) { FornitoreDescrizione="Agsm";Fornitorekyewords=""; }
          this.meta.updateTag({ name:'description', content:FornitoreDescrizione});
          this.meta.addTag({ name: 'keywords', content: Fornitorekyewords });
        }
        );

      // this.lstOfferteAlternative = this.service.getOfferteAlternativeByIdFornitoreIdComodity(this.idfornitore,this.idcomodity);
      this.lstOfferteAlternative=null;
      this.service.getOfferteAlternativeByIdFornitoreIdComodity(this.idfornitore, this.idcomodity).subscribe(data => this.lstOfferteAlternative=data);



      // In a real app: dispatch action to load the details here.
    });
    this.carousel = {
      grid: {xs: 1, sm: 2, md: 3, lg: 5, all: 0},
      slide: 1,
      speed: 400,
      interval: 5000,
      loop:true,
      animation: 'lazy',
      point: {
        visible: true
      },
      load: 1,
      touch: true,
      easing: 'ease'
    }
  }
  public myfunc(event: Event) {
    // carouselLoad will trigger this funnction when your load value reaches
    // it is helps to load the data by parts to increase the performance of the app
    // must use feature to all carousel
  }

}



// WEBPACK FOOTER //
// ./src/app/listaofferte/listaofferte.component.ts